<script setup>

import notification from "@/utils/plugins/NotificationService";
import { computed, onMounted, ref } from 'vue';
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";



import courseEnrollmentService from "@/api/services/courseEnrollment.service";

const courseDescription = ref();
const courseSessionStartAt = ref();
const courseSessionEndAt = ref();
const courseSessionStatus = ref();
const courseSessionGrade = ref(0);
const courseSessionCompletedAt = ref();

const course = computed(() => {
    if (props.session && props.session.session && props.session.session.course) {
        return props.session.session.course
    }
    return null;
});

const employee = computed(() => {
    if (props.session && props.session.employee) {
        return props.session.employee
    }
    return null;
})

const sesionStatus = ref([
    {
        value: "pending",
        name: "Pendiente"
    },
    {
        value: "confirmed",
        name: "Confirmado"
    },
    {
        value: "canceled",
        name: "Cancelado"
    },
    {
        value: "finished",
        name: "Finalizado"
    },
    {
        value: "disabled",
        name: "Deshabilitado"
    },
])

// eslint-disable-next-line no-undef
const emit = defineEmits(['closeDialog', 'reload'])

// eslint-disable-next-line no-undef
const props = defineProps({
    session: Object,
})


// eslint-disable-next-line no-unused-vars
const user = computed(() => {
    return authStore.getUserLogged;
})

const isAdmin = computed(() => {
    if (user.value) {
        return user.value.roles.includes('ROLE_ADMIN');
    }
    return false;
})

const params = ref({});

const authStore = useAuthStore();
const uiStore = useUiStore();

const selectedSession = computed(() => {
    if (props && props.session) {
        return props.session;
    } else {
        return null;
    }
})

onMounted(() => {
    const session = props.session.session;
    courseSessionStartAt.value = session.startAt;
    courseSessionEndAt.value = session.endAt;
    courseSessionStatus.value = props.session.status;
    courseSessionCompletedAt.value = props.session.completedAt;
    if (props.session.grade) {
        courseSessionGrade.value = parseInt(props.session.grade);
    }
    
    if(props.session && props.session.session && props.session.session.course && props.session.session.course.description){
        courseDescription.value = props.session.session.course.description
    }


})

const closeDialogNew = (saved = null) => {
    if (saved) {
        emit('closeDialog', saved)
    } else {
        emit('closeDialog')
    }
}
const editSession = () => {
    if (!courseSessionStatus.value) {
        notification.addNotification({
            type: 'error',
            message: 'No se ha seleccionado un estado',
            duration: 6000
        })
        return;
    }

    if (!selectedSession.value) {
        notification.addNotification({
            type: 'error',
            message: 'No se ha encontrado sesion',
            duration: 6000
        })
        return;
    }

    params.value = {
        'status': courseSessionStatus.value,
        'completedAt': courseSessionCompletedAt.value,
    };
    if (sesionStatus.value === 'completed') {
        params.value.grade = courseSessionGrade.value;
    }
    uiStore.startLoading();
    courseEnrollmentService.updateCourseEnrollment(props.session.id, params.value)
        .then((res) => {            
            if (res && (res.status === 200 || res.status === 201)) {
                notification.addNotification({
                    type: 'success',
                    message: 'Actualizada la sesion correctamente',
                    duration: 6000
                })
                closeDialogNew(true);
                emit('reload');
            }
            uiStore.stopLoading();
        })
        .catch(() => {
            uiStore.stopLoading();
        })
}


</script>

<template>
    <div>
        <div class="header">
            <img style="width: 30px; margin-bottom: 14px;" src="@/assets/icons/graduating-hat-blue.svg">
            <span class="header-title pl-4">
                Sesión {{ isAdmin ? 'de ' + employee.fullName : '' }} {{ course.name }}
            </span>
        </div>
        <div class="row f-flex">
            <div class="el-col-xs-24 col-md-12"
                v-if="courseDescription">
                <label class="w-100" for="description">Descripci&oacute;n de curso</label>
                <textarea v-model="courseDescription" id="description"
                    class="w-100 p-3 font18" disabled />
            </div>
            <div class="col-md-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">Fecha inicio curso</label>
                    <el-date-picker id="ffrom" v-model="courseSessionStartAt" name="deliv-date'" type="datetime"
                        style="width: 100%;" placeholder="Fecha de solicitud" format="DD/MM/YYYY HH:mm" disabled
                        value-format="YYYY-MM-DD HH:mm" :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
            <div class="col-md-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffto" class="w-100">Fecha fin curso</label>
                    <el-date-picker id="ffto" v-model="courseSessionEndAt" name="deliv-date'" type="datetime" disabled
                        style="width: 100%;" placeholder="Duración indefinida" format="DD/MM/YYYY HH:mm"
                        value-format="YYYY-MM-DD HH:mm" :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
            <div class="col-md-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="csStatus" class="w-100">Estado:</label>
                    <el-select id="csStatus" v-model="courseSessionStatus" filterable :disabled="!isAdmin"
                        placeholder="Seleccione el estado de la sesión" :value-key="'@id'">
                        <el-option v-for="stat in sesionStatus" :key="stat.value" :label="stat.name"
                            :value="stat.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="col-12" v-if="courseSessionStatus === 'completed'">
                <div class="row f-flex">
                    <div class="col-md-6 el-col-xs-24" v-if="selectedSession.status === 'completed'">
                        <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                            <label for="ffCompleted" class="w-100">Fecha curso completado</label>
                            <el-date-picker id="ffCompleted" v-model="courseSessionCompletedAt" name="deliv-date'"
                                type="datetime" :disabled="!isAdmin" style="width: 100%;"
                                placeholder="Fecha curso completado" format="DD/MM/YYYY HH:mm"
                                value-format="YYYY-MM-DD HH:mm" :picker-options="{ firstDayOfWeek: 1 }" />
                        </div>
                    </div>
                    <div class="col-md-6 el-col-xs-24">
                        <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                            <label for="csGrade" class="w-100">Nota:</label>
                            <el-input-number id="input-employee" v-model="courseSessionGrade" class="search-input"
                                :disabled="!isAdmin" style="width: 100%;" :min="0" :max="100"
                                placeholder="Indique la nota. Número del 0 al 100" :controls="false" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  Botones guardar y cancelar -->
        <div class="row footer">
            <div class="col-md-12 mt-4" style="margin-left: -10px;">
                <div class="d-flex justify-content-end gap-3">
                    <div class="col-md-3">
                        <button class="btn btn-block btn_yellow edit-button" @click="closeDialogNew(true)" style="">{{
                            isAdmin ? 'Cancelar' : 'Volver' }}
                        </button>
                    </div>
                    <div class="col-md-3" v-if="isAdmin">
                        <button type="submit" class="btn btn-block btn_red edit-button" @click="editSession">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-title {
    font-size: 30px;
    margin-left: 5px;
    font-weight: 800;
    letter-spacing: -0.05em;
    color: #474ce6;
}

.custom-textarea:deep(.el-textarea__inner) {
    font-size: 14px !important;
    border-radius: 20px;
}
</style>